import { toQueryString } from "src/utils/misc";
import { api } from ".";
export const getNiceToken = async (param)=>{
    let { returnUrl  } = param;
    const { data  } = await api.get("/nice/token/".concat(toQueryString({
        returnUrl
    })));
    return data;
};
